// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"switch-voice-button_wrapper__2DeEd"};